<ng-content select="[tiimeCardHeaderIcon]"></ng-content>
<ng-content select="[tiimeCardHeaderTitle]"></ng-content>
<ng-content select="[tiimeCardHeaderActions]"></ng-content>
